var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 306,
    viewBox: "0 0 356 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.442 0.382895C168.266 0.424248 130.705 15.8431 103.003 43.2563C75.3009 70.6694 59.7195 107.838 59.6777 146.606C59.6777 151.042 59.8988 155.448 60.3092 159.791L109.532 153.323C109.375 151.074 109.185 148.855 109.185 146.606C109.116 125.086 116.241 104.147 129.449 87.051C142.657 69.9549 161.208 57.6609 182.212 52.0839C203.216 46.5069 225.494 47.9599 245.577 56.2166C265.66 64.4733 282.42 79.0702 293.246 97.7339C304.073 116.398 308.359 138.08 305.436 159.405C302.513 180.73 292.546 200.5 277.087 215.636C261.628 230.772 241.545 240.424 219.965 243.089C198.386 245.755 176.521 241.283 157.777 230.372L130.024 270.989C149.469 282.862 171.433 290.11 194.188 292.163C216.943 294.215 239.87 291.016 261.164 282.818C282.459 274.62 301.541 261.645 316.912 244.915C332.282 228.184 343.521 208.153 349.745 186.397C355.97 164.641 357.009 141.753 352.783 119.532C348.556 97.3116 339.178 76.3638 325.387 58.336C311.595 40.3081 293.766 25.6917 273.301 15.6359C252.835 5.58003 230.292 0.358883 207.442 0.382895Z",
    fill: "#4D5359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.942 100.352C194.474 100.351 182.508 105.216 173.642 113.89C164.775 122.565 159.723 134.349 159.582 146.687L220.14 138.72L185.851 189.117C192.245 192.288 199.282 193.985 206.433 194.08C213.585 194.175 220.665 192.667 227.143 189.667C233.621 186.668 239.328 182.256 243.837 176.762C248.345 171.268 251.538 164.834 253.175 157.945C254.812 151.055 254.851 143.889 253.289 136.982C251.727 130.075 248.604 123.609 244.156 118.067C239.707 112.525 234.048 108.053 227.603 104.984C221.158 101.916 214.094 100.332 206.942 100.352Z",
    fill: "#626A72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8976 305.607L169.618 168.82L0.667969 191.629L64.6677 237.214L74.8976 305.607Z",
    fill: "#F95700"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyData);
export default __webpack_public_path__ + "static/media/EmptyData.82043bae2850a9c4428005f63bc6bb30.svg";
export { ForwardRef as ReactComponent };